import { api, createErrorResponse } from './index';

import { ADMIN_ROUTE_PREFIX } from './constants';

export async function getTags() {
  try {
    const response = await api.get(`${ADMIN_ROUTE_PREFIX}/tags`);
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}
